import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";

const MixerHelp = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>How to Use the Guest List</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="body1">
            The Guest List shows everyone currently checked in for this event.
          </Typography>
          <Typography variant="body1">
            • The circle percentage indicator shows your compatability score
            based on how you both completed your event profile
          </Typography>
          <Typography variant="body1">
            • Use the filter icon in the top right to narrow down the list based on specific questions in the event profile
          </Typography>
          <Typography variant="body1">
            • Tap on a guest to getter a better view and hit the heart if you
            like them. You can also take notes by tapping on the notes icon.
          </Typography>
          <Typography variant="body1">
            • If you don't see anyone on the guest list, it might mean the you filled out your profile incorrectly. Go find a host and they can help you figure it out. 
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" fullWidth>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MixerHelp;
